import React from "react";
import { colors } from "../../colors";

type Props = {
  selectedFilter: string;
  setSelectedFilter: React.Dispatch<React.SetStateAction<string>>;
};

const FilterButtons: React.FC<Props> = ({
  selectedFilter,
  setSelectedFilter,
}) => {
  const filters = ["All", "ui", "api", "mob"];

  return (
    <div className="flex flex-wrap justify-center space-x-0 lg:mt-0">
      {filters.map((filter, index) => (
        <button
          key={index}
          className={`lg:px-4 px-9 py-2 ${
            index === 0
              ? "rounded-l-lg"
              : index === filters.length - 1
              ? "rounded-r-lg"
              : ""
          }`}
          style={{
            backgroundColor:
              selectedFilter === filter
                ? colors.filterButtonsActive
                : colors.filterButtonsUnActive,
            color: colors.filterButtonsText,
          }}
          onClick={() => setSelectedFilter(filter)}
        >
          {filter.toUpperCase()}
        </button>
      ))}
    </div>
  );
};

export default FilterButtons;
